import React from "react";
import inc from "ramda/src/inc";
import range from "ramda/src/range";

import { Table } from "../../UI/Table";
import { TableRow } from "../../UI/TableRow";
import { TableHead } from "../../UI/TableHead";
import { TableCell } from "../../UI/TableCell";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { ModalProvider } from "../../contexts/ModalContext";
import { UserNameLink } from "../UserNameLink";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";
import { PageTablePagination } from "../PageTablePagination";

interface IProps {
  roommatesQty: number;
  results: any[];
  isLoading: boolean;
  reloadResults: VoidFunction;
}

export const RoommateMatchingReportTable: React.FC<IProps> = (props) => {
  const { isEntrata, isRms } = useSelectedNetworkImportTypes();

  const getEmptyCells = (occupantsQty: number) =>
    range(0, props.roommatesQty - occupantsQty);
  const isUniqueId = isEntrata || isRms;

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Roommate 1</TableCell>
            {range(1, inc(props.roommatesQty)).map((idx) => (
              <TableCell key={idx}>Roommate {inc(idx)}</TableCell>
            ))}
            {isUniqueId && <TableCell>Roommate Unique Id</TableCell>}
          </TableRow>
        </TableHead>
        <EnhancedTableBody colSpan={10} isLoading={props.isLoading}>
          {props.results.map((result) => (
            <TableRow key={result.uid}>
              <TableCell>
                <ModalProvider>
                  <UserNameLink
                    openNewTab
                    name={`${result.firstName} ${result.lastName}`}
                    id={result.uid}
                  />
                </ModalProvider>
              </TableCell>
              {result.roommates.map((roommate: any) => (
                <TableCell key={roommate.uid}>
                  <ModalProvider>
                    <UserNameLink
                      openNewTab
                      id={roommate.uid}
                      name={`${roommate.firstName} ${roommate.lastName}`}
                    />
                  </ModalProvider>
                </TableCell>
              ))}
              {getEmptyCells(result.roommates.length).map((idx) => (
                <TableCell key={idx} />
              ))}
              {isUniqueId && <TableCell>{result.uniqueId}</TableCell>}
            </TableRow>
          ))}
        </EnhancedTableBody>
      </Table>
      <PageTablePagination />
    </>
  );
};
